import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import CrudForm from '../../crud/CrudForm'
import { myuserService as service } from '../../../services'

const initElement = {
    oldpass: '',
    newpass: '',
    renewpass: '',
}

type FormAdministratorParms = {
    id: string
}

export default function FormChangePass() {
    const [objectform, setObjectform] = React.useState({ ...initElement })
    let { id } = useParams<FormAdministratorParms>()
    const [idRow, setIdrow] = useState(id ? Number(id) : 0)

    const estructureform = [
        {
            type: 'input',
            name: 'oldpass',
            inputtype: 'password',
            col: 4,
        },
        {
            type: 'input',
            name: 'newpass',
            inputtype: 'password',
            col: 4,
        },
        {
            type: 'input',
            name: 'renewpass',
            inputtype: 'password',
            col: 4,
        },
    ]

    const recoveryElement = function (objectedit, element) {
        return objectedit
    }

    const isValid = function (object) {
        if (!object['oldpass']) {
            return 'Debe indicar la contraseña actual'
        }
        if (!object['newpass']) {
            return 'Debe indicar la nueva contraseña'
        }
        if (object['newpass'].length < 8) {
            return 'La nueva contraseña debe tener al menos 8 caracteres'
        }
        if (object['newpass'] != object['renewpass']) {
            return 'La nuevas contraseñas no coinciden'
        }

        return null
    }

    return (
        <>
            <CrudForm
                objectform={{ ...initElement }}
                estructureform={estructureform}
                i18n={'changepass'}
                urledit={'/changepass/'}
                urlCancel={'/changepass'}
                service={service}
                recoveryElement={recoveryElement}
                valid={isValid}
                notredirect={true}
            />
        </>
    )
}
